import React from "react";
import { Spin } from "antd";

export default function LoadingOverlay() {
  return (
    <div
      style={{
        flex: 1,
        height: "100vh",
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin size={"large"} />
    </div>
  );
}
